import { Checkbox } from "antd";
import React from "react";

const DataList = ({ data, selected, setSelected }) => {
  return (
    <div className="h-[calc(100vh-72px-48px-48px-16px-36px)] overflow-y-scroll">
      {data?.map((item, index) => {
        const checked = selected.includes(item.id);

        return (
          <div
            key={item?.name || index}
            className={`flex items-center h-11 border-b-[0.5px] border-light-grey
                            ${checked ? "bg-[#CEDCDD]" : ""}
                            `}
          >
            <div className="w-10 flex items-center justify-center">
              <Checkbox
                checked={checked}
                onClick={() => {
                  let current = [...selected];

                  if (current.includes(item.id)) {
                    current = current.filter((c) => c !== item.id);
                  } else {
                    current.push(item.id);
                  }

                  setSelected([...current]);
                }}
              />
            </div>

            <p className="px-4 py-[11px] font-aileron font-semibold text-xs capitalize">
              {item?.firstName
                ? `${item?.firstName || "--"} ${item.lastName || "--"}`
                : "--"}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default DataList;
